import root from 'window-or-global';

if (root && root.__webpack_asset_path) {
    //eslint-disable-line
    __webpack_public_path__ = root['__webpack_asset_path']; //eslint-disable-line
}

import 'console-shim';
import React from 'react';
import ReactDOM from 'react-dom';
// import ga from 'react-ga';
import {BrowserRouter} from 'react-router-dom';
import {Provider} from 'react-redux';
import {fromJS} from 'immutable';
import {configureStore} from './configureStore';
import {setLocale} from 'epic-common/src/locale';
import ScrollToTopOnUpdate from 'epic-react-common/src/components/ScrollToTopOnUpdate';
import RefreshOnSessionChange from 'epic-react-common/src/components/RefreshOnSessionChange';
import App from './App';
import './thirdPartyStyles';
import {LocalizationContext} from 'epic-localization/src/context/LocalizationContext';
import pako from 'pako';

/**
 * The react app will look for a DOM element with this ID and insert itself there.
 */
// ga.initialize('UA-48247113-3', 'none');

let initialState = fromJS({});
let epicState = root.__epic_client_state;
if (epicState && typeof epicState === 'string') {
    setLocale(root.__locale);
    epicState = JSON.parse(pako.inflate(epicState.split(','), {to: 'string'}));
    initialState = fromJS(epicState);
}
const {
    user: {isLoggedIn}
} = epicState;
const store = configureStore(initialState);
const localization = epicState.localization || {};
const i18nContext = {
    messages: localization.messageProperties,
    supportedLocales: localization.supportedLocales,
    locale: localization.locale
};

ReactDOM.hydrate(
    <BrowserRouter>
        <RefreshOnSessionChange isLoggedIn={isLoggedIn}>
            <Provider store={store}>
                <ScrollToTopOnUpdate>
                    <LocalizationContext.Provider value={i18nContext}>
                        <App />
                    </LocalizationContext.Provider>
                </ScrollToTopOnUpdate>
            </Provider>
        </RefreshOnSessionChange>
    </BrowserRouter>,
    root.document.getElementById('affiliateWrapper')
);
